import { useMemo } from 'react';

import { usePaymentMethodCardsQuery } from './graphql/PaymentMethodCards.generated';

export const usePaymentMethodCards = (
  props: UsePaymentMethodCardsDataProps,
) => {
  const { pause } = props;

  const [{ data, fetching }] = usePaymentMethodCardsQuery({
    requestPolicy: 'cache-and-network',
    pause,
  });

  const isLoadingPaymentMethodCards = fetching;
  const paymentMethodCards = useMemo(
    () => data?.paymentMethodCards ?? [],
    [data?.paymentMethodCards],
  );

  return {
    paymentMethodCards,
    isLoadingPaymentMethodCards,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UsePaymentMethodCardsDataProps = Readonly<{
  pause: boolean;
}>;
